import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatValue } from "./utils/formatValue";

export default function SportTable({
  sport,
  participantScores,
  setEditDialog,
  setRoundToEdit,
  setParticipantToEdit,
  editable,
}) {
  const handleCellClick = (participantIndex, roundIndex) => {
    setParticipantToEdit(participantIndex);
    setRoundToEdit(roundIndex);
    setEditDialog(true);
  };

  // Create dynamic columns for each round
  const roundColumns = [
    ...[...Array(sport.rounds + (sport.tieBreakingRounds || 0)).keys()].map(
      (i) => ({
        field: `round_${i}`,
        header: `${i + 1}${i >= sport.rounds ? " (T)" : ""}`,
        index: i,
      })
    ),
  ];

  // Prepare participant data with round fields
  const tableData = participantScores.map((p, participantIndex) => {
    const roundsObj = {};
    p.rounds.forEach((r, roundIndex) => {
      roundsObj[`round_${roundIndex}`] = r;
    });
    return {
      ...p,
      ...roundsObj,
      participantIndex,
    };
  });

  const roundBodyTemplate = (rowData, column) => {
    const roundIndex = column.index;
    return (
      <div
        style={{
          textAlign: "center",
          cursor: "pointer",
          backgroundColor: "#f9f9f9",
        }}
        onClick={() => {
          if (editable) {
            handleCellClick(rowData.participantIndex, roundIndex);
          }
        }}
      >
        {formatValue(rowData[`round_${roundIndex}`], sport.time)}
      </div>
    );
  };

  const finalScoreTemplate = (rowData) =>
    formatValue(rowData.score, sport.time);

  return (
    <DataTable
      key={sport.id} 
      value={tableData}
      responsiveLayout="scroll"
      sortField="score"
      sortOrder={sport.ascending ? 1 : -1}
    >
      <Column field="name" header="Nimi" />
      {roundColumns.map((col) => (
        <Column
          key={col.index}
          field={col.field}
          header={col.header}
          body={(rowData) => roundBodyTemplate(rowData, col)}
        />
      ))}
      <Column
        sortable
        field="score" // numeric sorting
        header={
          sport.directPoints
            ? "Pisteet"
            : sport.combined
            ? "Yhteistulos"
            : "Paras kierros"
        }
        body={finalScoreTemplate}
      />
    </DataTable>
  );
}
